import React, { ReactElement, ReactNode } from 'react'

import { Text } from '../../../Text'
import * as Styled from './styles'

interface ErrorInfoProps {
  children: ReactNode
}

export const ErrorInfo = ({ children }: ErrorInfoProps): ReactElement => (
  <Styled.ErrorInfoWrapper>
    <Text variant="bodySM" colorVariant="danger" inline>
      {children}
    </Text>
  </Styled.ErrorInfoWrapper>
)
